export default "__VITE_ASSET__B7DCoD7X__"